<script setup lang="ts">
/**
 * UI-kit component
 * Category: Switchers
 * Name: AppSwitcherList
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=4247-47021&m=dev
 */

defineOptions({
  name: 'AppSwitcherList',
})
</script>

<template>
  <div class="ui-app-switcher-list">
    <slot />
  </div>
</template>

<style lang="scss" scoped src="../styles/_app-switcher-list.scss" />
